import { render, staticRenderFns } from "./TransactionPaymentDetails.vue?vue&type=template&id=5272422a&"
import script from "./TransactionPaymentDetails.vue?vue&type=script&lang=js&"
export * from "./TransactionPaymentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports